import { render, staticRenderFns } from "./ActiveCodeExcelExport.vue?vue&type=template&id=70873d6e&"
import script from "./ActiveCodeExcelExport.vue?vue&type=script&lang=js&"
export * from "./ActiveCodeExcelExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports